import { getFullFillmentFilter } from "./typesenseUtils";

export const fetchFulfilledCounts = async ({
  adapter,
  supplierDiscoveryCollectionName,
  preFacetedPartNumbers,
  pinnedSupplierIds,
  geoDistanceFilter,
  excludeSupplierIds,
  isPinned = false,
}: any) => {
  try {
    const baseFilter = getFullFillmentFilter(preFacetedPartNumbers);

    const filterConditions = [];

    if (baseFilter) {
      filterConditions.push(baseFilter);
    }

    if (geoDistanceFilter && geoDistanceFilter.trim()) {
      filterConditions.push(geoDistanceFilter);
    }

    if (isPinned && pinnedSupplierIds && pinnedSupplierIds.length > 0) {
      const supplierFilter = `supplierId:=[${pinnedSupplierIds.join(",")}]`;
      filterConditions.push(supplierFilter);
    }

    if (excludeSupplierIds && excludeSupplierIds.length > 0) {
      const exclusionFilter = `supplierId:!=[${excludeSupplierIds.join(",")}]`;
      filterConditions.push(`(${exclusionFilter})`);
    }

    const finalFilter = filterConditions.join(" && ");
    const response = await adapter.typesenseClient
      .collections(supplierDiscoveryCollectionName)
      .documents()
      .search({
        q: "*",
        query_by: "rootPartNumber",
        facet_by: "supplierInfo",
        filter_by: finalFilter,
        max_facet_values: 1000,
      });

    const fulfilledMap: Map<string, number> = new Map();
    for (const facet of response.facet_counts?.[0]?.counts || []) {
      fulfilledMap.set(facet.value, facet.count);
    }
    return fulfilledMap;
  } catch (error) {
    console.error("Error fetching fulfilled counts:", error);
    return new Map();
  }
};
